import React, { useState } from "react";

import { Box, FormControl, InputLabel, OutlinedInput, InputAdornment } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import Slider, { SliderThumb, SliderValueLabelProps } from "@mui/material/Slider";
import { styled } from "@mui/material/styles";

import "./style.css";

const CustomSlider = styled(Slider)(({ theme }) => ({
    color: "#155B75",
    height: 3,
    padding: "13px 0",
    "& .MuiSlider-thumb": {
        height: 27,
        width: 27,
        backgroundColor: "#fff",
        border: "1px solid currentColor",
        "&:hover": {
            boxShadow: "0 0 0 8px rgba(58, 133, 137, 0.16)",
        },
        "& .custom-bar": {
            height: 9,
            width: 1,
            backgroundColor: "currentColor",
            marginLeft: 1,
            marginRight: 1,
        },
    },
    "& .MuiSlider-track": {
        height: 3,
    },
    "& .MuiSlider-rail": {
        color: theme.palette.mode === "dark" ? "#bfbfbf" : "#d8d8d8",
        opacity: theme.palette.mode === "dark" ? undefined : 1,
        height: 3,
    },
}));

function CustomThumbComponent(props) {
    const { children, ...other } = props;
    return (
        <SliderThumb {...other}>
            {children}
            <span className="custom-bar" />
            <span className="custom-bar" />
            <span className="custom-bar" />
        </SliderThumb>
    );
}

const RangeSlider = (props) => {
    let { multipleOf, defaultValue } = props;
    defaultValue = defaultValue?.length > 0 ? [...defaultValue] : [0, 100 * multipleOf];
    const [value, setValue] = React.useState(defaultValue);
    const handleChange = (event, newValue) => {
        setValue([newValue[0] * multipleOf, newValue[1] * multipleOf]);

        props.onChange(event, [newValue[0] * multipleOf, newValue[1] * multipleOf]);
    };
    return (
        <div className="RangeSlider">
            <CustomSlider
                slots={{ thumb: CustomThumbComponent }}
                getAriaLabel={(index) => (index === 0 ? "Minimum price" : "Maximum price")}
                defaultValue={[value[0] / multipleOf, value[1] / multipleOf]}
                onChange={handleChange}
            />
            <Grid container spacing={2} sx={{ mt: "10px" }}>
                <Grid item xs={6} sx={{ paddingLeft: "0px" }}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="outlined-adornment-amount">Min</InputLabel>
                        <OutlinedInput
                            id="outlined-adornment-amount"
                            startAdornment={<InputAdornment position="start">$</InputAdornment>}
                            label="Amount"
                            value={value[0] === 0 && value[1] === 100 * multipleOf ? "" : value[0]}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={6} sx={{ paddingRight: "0px" }}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="outlined-adornment-amount">Max</InputLabel>
                        <OutlinedInput
                            id="outlined-adornment-amount"
                            startAdornment={<InputAdornment position="start">$</InputAdornment>}
                            label="Amount"
                            value={value[1] === 100 * multipleOf && value[0] === 0 ? "" : value[1]}
                        />
                    </FormControl>
                </Grid>
            </Grid>
        </div>
    );
};

export default RangeSlider;
